import { computed, Signal } from '@angular/core';
import { AssetAnalysisItem, AssetResponse } from './services/api';

// The canonical analyses[] lookup, shared by core.ts and the analysis-consuming V3 components:
// one analysis by type; null when missing, cache_miss, or explicitly content.has_data === false.
export function findAnalysisSignal(
  v2Data: Signal<AssetResponse | null>,
  type: string,
): Signal<AssetAnalysisItem | null> {
  return computed(() => {
    const analysis = v2Data()?.analyses.find((a) => a.analysis_type === type);
    if (!analysis || analysis.output_type === 'cache_miss') return null;
    if (analysis.content?.['has_data'] === false) return null;
    return analysis;
  });
}

// Date derived from an analysis's generated_at. null when missing.
export function updatedAtSignal(analysis: Signal<AssetAnalysisItem | null>): Signal<Date | null> {
  return computed(() => {
    const generatedAt = analysis()?.generated_at;
    return generatedAt ? new Date(generatedAt) : null;
  });
}

// Body text of a `{ body: string }` content field, e.g. content.summary.body. '' when absent.
export function analysisBodyText(
  content: Record<string, unknown> | null | undefined,
  field: string,
): string {
  return (content?.[field] as { body?: string } | undefined)?.body ?? '';
}
